import { render, staticRenderFns } from "./StudentVariant.vue?vue&type=template&id=1013ee7c&scoped=true&"
import script from "./StudentVariant.vue?vue&type=script&lang=js&"
export * from "./StudentVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013ee7c",
  null
  
)

export default component.exports